import React from 'react';

import HeaderSecondary from '@components/HeaderSecondary';

import SubHeader from './SubHeader';
import FilterSection from './FilterSection';
import HealthQuoteList from './HealthQuoteList';
import FilterProvider from './FilterProvider';
import ComparableHealthQuote from './ComparableHealthQuote';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';
import { routeHealthQuotePage } from '@components/HealthQuotePage';

const HealthQuoteResultPage = () => {
  const params = useQuoteOptionParams();

  return (
    <FilterProvider>
      <HeaderSecondary />
      <SubHeader formLinkTo={routeHealthQuotePage({ path: 'members', ...params })} />
      <FilterSection />
      <HealthQuoteList />
      <ComparableHealthQuote />
    </FilterProvider>
  );
};

export { HealthQuoteResultPage };
